<template>
  <div class="authorization">
    <div class="scroll-box" :class="paddingTopWithOutNavBar">
      <h2>企业信用信息查询报送授权书</h2>
      <section>
        <p class="first">
          <span class="text-with-underline">{{fullBankName}}</span>：
          <!-- （填写金融机构全称） -->
        </p>
        <!-- （填写申请/参与单位全称，以下简称“本单位”） -->
        <p>
          本单位
          <span class="text-with-underline">{{AuthCompanyName}}({{companyId}})</span> 在贵行（社）申请办理客户评级授信、信贷业务、信用卡等金融产品和服务，在贵行（社）采取必要措施保障信息安全的前提下，现就贵行（社）通过浙江省金融综合服务平台查询和使用本单位相关信息授权如下：
        </p>
        <p>一、贵行（社）有权基于业务办理和贷后管理之目的，通过浙江省金融综合服务平台查询和使用本单位相关信息，相关信息包括但不限于：</p>
        <p>1.本单位工商登记信息、海关进出口信息、纳税信息、财务信息、抵质押等信息。</p>
        <p>2.本单位涉及资产被查封、扣押或被强制执行情况、法院诉讼判决、行政处罚等信息；</p>
        <p>3.其他通过省公共信息平台可查询到的相关信息。</p>
        <p>二、按照有关法律法规或其他规范性文件或金融监管机构要求，贵行（社）有权将本单位的基本信息和信贷信息提供给监管部门以及其承建的浙江省金融综合服务平台基础数据库。</p>
        <!-- <p>三、本单位同意并不可撤销地授权贵行（社）出于为客户提供金融服务之目的，将本单位相关信息在贵行（社）的分支机构和集团成员之间进行内部共享；授权贵行（社）出于债权转让、金融服务外包等需要，将本单位相关信息提供给有关的第三方机构。</p> -->
        <!-- <p>四、在使用本单位信息时，贵行（社）会采取必要措施保障信息安全，防止本人信息非法泄露或不当使用。</p> -->
        <p>本授权书自【{{nowDate}}】起生效。</p>
        <p></p>
        <div class="foot">
          <span id="companyName">{{AuthCompanyName}}</span>
          <span id="nowDate">{{nowDate}}</span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getParamFromUrl, formatDate } from '@/utils/common.js'
import { mapState } from 'vuex'
export default {
  props: {
    companyName: String,
    uniscid: String
  },
  data () {
    return {
      nowDate: (formatDate(new Date(), 'yyyy年MM月dd日'))
    }
  },
  computed: {
    paddingTopWithOutNavBar () {
      return this.isZYAPP ? 'paddingTopWithOutNavBar' : ''
    },
    fullBankName () {
      return this.isZYAPP ? decodeURI(escape(getParamFromUrl('fullBankName'))) : this.productDetail.fullBankName
    },
    AuthCompanyName () {
      return this.companyName || this.userInfo?.companyName
    },
    companyId () {
      return this.uniscid || this.userInfo.uniscid
    },
    ...mapState('user', {
      userInfo: state => state.userInfo
    }),
    ...mapState('product', {
      productDetail: state => state.productDetail || {}
    })
  }
}
</script>

<style lang="scss" scoped>
.authorization {
  section {
    margin: 33px 50px 50px 50px;
    h1 {
      text-align: left;
    }
    p {
      text-align: left;
      // line-height: 36px;
      line-height: 42px;
      b {
        font-weight: bolder;
      }
      text-indent: 2em;
      margin-bottom: 10px;
    }
    .first {
      margin-top: 20px;
      text-indent: 0em;
      // text-indent: 1em;
    }
    .tip {
      color: #fe3116;
    }
  }
}
.scroll-box {
  padding-bottom: 0px;
}
.paddingTopWithOutNavBar {
  padding-top: 0px;
}
.text-with-underline {
  width: fit-content;
  border-bottom: 2px black solid;
}
.foot {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  #companyName {
    margin-top: 15px;
    border-bottom: 2px black solid;
  }
  #nowDate {
    margin-top: 15px;
    border-bottom: 2px black solid;
  }
}
</style>
